import classnames from 'classnames';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Radio } from '@material-ui/core';

import { PaymentAmountContainer } from '../payment-amount';
import { currency, twoDigitsAmount } from 'src/util/formatters';
import { MatField } from 'src/core/components/mat-field';

import styles from './payment-amount.less';

interface Props {
    container: PaymentAmountContainer;
}

export const PaymentAmount = observer<React.SFC<Props>>(({ container: { data } }) => {
    if (data.errorMessage || !data.fullBalance) {
        return null;
    }

    return (
        <div className={classnames('card', styles.card)}>
            <h3>Payment Amount</h3>

            <label
                className={classnames('radioButtonLabel', { checked: data.isFullBalance.value })}
            >
                <Radio checked={data.isFullBalance.value} onChange={data.handleFullAmountTrue} />
                <span className="radioLabelContent">Full balance</span>
                <strong className={classnames('radioLabelContent', styles.rightLabel)}>
                    {currency(data.fullBalance)}
                </strong>
            </label>
            {data.partialPaymentEnabled && (
                <label>
                    <Radio
                        checked={!data.isFullBalance.value}
                        onChange={data.handleFullAmountFalse}
                    />
                    <MatField
                        fieldState={data.customAmount}
                        autoComplete="off"
                        fullWidth
                        placeholder={data.isFullBalance.value ? 'Other amount' : ''}
                        onChange={data.handleFullAmountFalse}
                        onFocus={data.handleFullAmountFalse}
                        startAdornment={
                            data.isFullBalance.value && !data.customAmount.value ? null : '$'
                        }
                        formatter={twoDigitsAmount}
                    />
                </label>
            )}
        </div>
    );
});
